import React from "react";
import { Reveal, SectionLabel, StatBlock } from "../components/primitives";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="pt-20 pb-16 lg:pt-32 lg:pb-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal><SectionLabel>About Folks Funds</SectionLabel></Reveal>
          <Reveal delay={80}>
            <h1 className="font-display font-bold tracking-[-0.035em] leading-[0.94] text-5xl sm:text-7xl lg:text-[104px] text-[#111A15] max-w-5xl">
              We don't just write cheques. We build asset-class businesses.
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="py-16 lg:py-24 border-y border-[#E5E5E0] bg-[#E8ECE9]/40">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <SectionLabel>Mission</SectionLabel>
            <h2 className="font-display font-medium tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#111A15] leading-[1.05]">
              Accelerating India's green economy by investing in breakthrough technology across thirteen ESG sectors.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 space-y-6 text-[16px] text-[#4A5E51] leading-relaxed">
            <p>Folks Funds is the investment arm of the Folks ecosystem — alongside <span className="text-[#111A15] font-medium">Folks Motor</span> (the operator) and <span className="text-[#111A15] font-medium">Folks Finance</span> (the capital enabler). Together, the three entities form a flywheel that compounds returns for our portfolio companies.</p>
            <p>We focus on building asset-class businesses by integrating proprietary technology with real-world infrastructure — turning supply chains into scalable, investable assets that attract global capital.</p>
            <p>Our approach is thesis-driven and bottom-up. We invest seed to Series A, when the technology is ready and the market is hunting for product-fit. Every conviction passes three tests: <span className="text-[#111A15]">a structural problem</span>, <span className="text-[#111A15]">defensible technology</span>, and <span className="text-[#111A15]">ESG alpha</span> that creates real business advantage.</p>
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24 border-b border-[#E5E5E0]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-2">
                <SectionLabel>Our ambition</SectionLabel>
              </div>
              <div className="lg:col-span-10">
                <p data-testid="supply-chain-callout" className="font-display font-bold tracking-[-0.02em] leading-[1.05] text-3xl sm:text-5xl lg:text-[64px] text-[#111A15]">
                  We are creating <span className="italic">supply chain</span> as an <span className="text-[#C44900]">asset class</span>.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <SectionLabel>Fund snapshot</SectionLabel>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10 mt-8">
            <Reveal><StatBlock value="₹500 Cr" label="Target corpus" hint="AIF Category II" /></Reveal>
            <Reveal delay={70}><StatBlock value="₹100 Cr" label="First close" hint="Achieved" /></Reveal>
            <Reveal delay={140}><StatBlock value="Deployment-ready" label="Investment thesis" hint="Backing scalable technology-led industrial businesses with a clear path to deployment." /></Reveal>
            <Reveal delay={210}><StatBlock value="22–28%" label="Target Net IRR" hint="5–10x MOIC ambition" /></Reveal>
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-[#111A15] text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#9DB0A3] mb-5">— India's moment</p>
            <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.04]">
              The largest capital allocation moment in modern history is here.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 space-y-6 text-[15px] text-[#9DB0A3] leading-relaxed">
            <p>India is building green infrastructure from scratch — not retrofitting a fossil-fuel legacy. PLI, FAME and the National Hydrogen Mission are channelling real capital into manufacturing.</p>
            <p>India is transitioning from a <span className="text-white">"service-led" economy</span> to a <span className="text-white">"Deeptech-manufacturing"</span> powerhouse. As manufacturing costs in the US and China continue to evolve, India's competitive positioning has helped it capture a larger share of the global investment shift, drawing billions in annual FDI into its expanding industrial corridors.</p>
            <p>We sit at the intersection of policy tailwinds, cost advantage and a leapfrog dynamic — picking the companies that will define the next decade of India's green economy.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
